<template>
  <div class="homepage-live-events">
      <div class="title">
        <h5><b>Canlı</b> Bahisler (221)</h5>
        <div class="sports">
            <ul>
              <li><a class="active" href="">Futbol</a></li>
              <li><a href="">Basketbol</a></li>
              <li><a href="">Tenis</a></li>
            </ul>
        </div>
      </div>
      <div class="content">
          <div class="event">
              <table>
                <thead>
                  <th :colspan="isMobile ? '2' : '3'">Futbol</th>
                  <th colspan="1" class="odds">
                    <span class="col">1</span>
                    <span class="col">X</span>
                    <span class="col">2</span>
                  </th>
                  <td v-if="!isMobile"></td>
                </thead>
                <tbody>
                  <tr v-for="x in 5" :key="x">
                    <td class="time" v-if="!isMobile">
                      <span>Ikinci Yari</span>
                      <br >
                      84’
                    </td>
                    <td class="team">
                      Manchester City
                      <br>
                      Manchester United
                      <div v-if="isMobile" class="time">Ikinci Yari 84’</div>
                    </td>
                    <td class="score">
                      <span>1</span>
                      <span>1</span>
                      <div v-if="isMobile" class="other">+22 ></div>
                    </td>
                    <td>
                      <div class="odds">
                        <OddButton :outcome="isMobile ? '1' : 'Ev Sahibi'" odd="1.90" v-for="x in 3" :key="x"></OddButton>
                      </div>
                    </td>
                    <td class="other" v-if="!isMobile">
                      <a href="">+ 222</a>
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>
      </div>
      
  </div>
</template>

<script>
  import OddButton from '../Common/Sportsbook/OddButton'
  export default{
    components:{
      OddButton,
    }
  }

</script>